import { useQuery, UseQueryResult } from 'react-query';
import { RevenueCategory } from 'types';
import { client } from 'utils/api-client';

function useRevenueCategories(): UseQueryResult<{
  data: Array<RevenueCategory>;
}> {
  return useQuery(['revenueCategories'], () => client.get(`revenue-categories`));
}

export default useRevenueCategories;
